export default __webpack_public_path__ + "static/media/Immaculate.4ba48dc0.jpg";